import { FETCH_TECHLANDSCAPE_FAILURE, FETCH_TECHLANDSCAPE_REQUEST, FETCH_TECHLANDSCAPE_SUCCESS } from "../actions/techLandscapeActions";

  const initialState = {
    techLandscapeData: [],
    techLandscapeLoading: false,
    techLandscapeError: null,
  };
  
  const techLandscapeReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_TECHLANDSCAPE_REQUEST:
        return { ...state, techLandscapeLoading: true , payload: action.payload};
      case FETCH_TECHLANDSCAPE_SUCCESS:
        return { ...state, techLandscapeLoading: false, techLandscapeData: action.payload };
      case FETCH_TECHLANDSCAPE_FAILURE:
        return { ...state, techLandscapeLoading: false, techLandscapeError: action.payload };
      default:
        return state;
    }
  };
  
  export default techLandscapeReducer;
  